import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, map, retry } from 'rxjs';
import { Clinic } from '../models/clinic.model';

const BASE_URL = environment.base_url;
const BASE_URL_SECOND = environment.base_url_second; // Esta es DEV

@Injectable({
    providedIn: 'root'
})
export class ClinicService {

    constructor(
        private http: HttpClient
    ) { }

    getClinics(clientIDs: string[]): Observable<Clinic[]> {

        const url = `${BASE_URL_SECOND}/clinics/by-client-ids`;

        const body = {
            clientIDs
        }

        return this.http.post<Clinic[]>(url, body)
    }

    getClinicsByClientId(clientId: string): Observable<Clinic[]> {

        const url = `${BASE_URL_SECOND}/clinics/${clientId}`;
        const token = localStorage.getItem('token') || '';

        const headers = {
            'X-Amz-Security-Token': token
        }

        return this.http.get<Clinic[]>(url, { headers })
    }

    getClinicById(clinicId: string): Observable<Clinic> {

        const url = `${BASE_URL_SECOND}/clinic/${clinicId}`;
        const token = localStorage.getItem('token') || '';

        const headers = {
            'X-Amz-Security-Token': token
        }

        return this.http.get<Clinic>(url, { headers })
    }

    createClinic(clinicData: Clinic) {

        const url = `${BASE_URL_SECOND}/clinic`;
        const token = localStorage.getItem('token') || '';

        const headers = {
            'X-Amz-Security-Token': token
        }

        return this.http.post(url, clinicData).pipe(retry(2))
    }

    updateClinic(clinicId: string, clinicData: Clinic) {

        const url = `${BASE_URL_SECOND}/clinic/${clinicId}`;
        const token = localStorage.getItem('token') || '';

        const headers = {
            'X-Amz-Security-Token': token
        }

        const body = clinicData

        return this.http.put(url, body, { headers }).pipe(
            map((resp) => resp)
        )
    }

    updateIdentifiersList(clinic: Clinic) {
        const url = `${BASE_URL_SECOND}/clinic/identifiersList`
        const token = localStorage.getItem('token') || '';

        const headers = {
            'X-Amz-Security-Token': token
        }

        return this.http.put(url, {
            clinicID: clinic.ID,
            connectedPlatform: {
                name: "Edser",
                identifier: clinic.connectedPlatform.identifier,
                identifiersList: clinic.connectedPlatform.identifiersList
            }
        }, { headers })
    }

}
